import MenuNavbarMobile from './menu-navbar-mobile';

export default MenuNavbarMobile;